/**
 * RecentLeadsCard — lista “Lead recenti” della Dashboard.
 * ★ Fase 59.P2 — estratto da DashboardPage.jsx. Comportamento e testid invariati.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '../ui/card';
import { ScoreBadge } from '../Badges';
import { fmtRelative, SOURCE_LABELS } from '../../lib/constants';
import { ChevronRight } from 'lucide-react';

export function RecentLeadsCard({ recent, loading }) {
  const { t } = useTranslation();
  return (
    <Card className="border-border" data-testid="recent-leads-card">
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="text-[11px] uppercase tracking-wide text-muted-foreground">{t('dashboard.recentLeads', 'Lead recenti')}</div>
          <Link to="/app/leads" className="text-xs text-[hsl(var(--primary))] inline-flex items-center hover:opacity-80" data-testid="recent-leads-see-all">
            Vedi tutti <ChevronRight className="w-3 h-3" />
          </Link>
        </div>
        <div className="space-y-1.5">
          {loading && <div className="text-sm text-muted-foreground">{t('common.loading', 'Caricamento…')}</div>}
          {recent.map((l) => (
            <Link
              key={l.id}
              to={`/app/leads/${l.id}`}
              data-testid={`recent-lead-${l.id}`}
              className="flex items-center gap-2 px-2 py-2 rounded-md hover:bg-[hsl(var(--accent))] transition-colors"
            >
              <div className="w-7 h-7 rounded-full bg-[var(--surface-2)] grid place-items-center font-serif text-xs text-[hsl(var(--primary))]">
                {(l.name || '?').slice(0, 1).toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm leading-tight truncate">{l.name}</div>
                <div className="text-[11px] text-muted-foreground">
                  {SOURCE_LABELS[l.source] || l.source} · {fmtRelative(l.created_at)}
                </div>
              </div>
              <ScoreBadge score={l.score} />
            </Link>
          ))}
          {!loading && recent.length === 0 && (
            <div className="text-sm text-muted-foreground py-6 text-center">{t('dashboard.noRecentLeads', 'Nessun lead recente.')}</div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
